import { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import { Message, StyledCheck, TitleModal } from './styles'
import Button from 'shared/components/Button'
import Modal from 'shared/components/Modal'

type TProps = {
  openModal: boolean
  loading: boolean
  closeModal: () => void
  handleBaixarPdfBoletoDeposito: () => Promise<void>
}

const ModalSucesso: FunctionComponent<TProps> = ({
  handleBaixarPdfBoletoDeposito,
  openModal,
  closeModal,
  loading,
}) => {
  return (
    <Modal
      openModal={openModal}
      curvature={true}
      showCloseButton={true}
      onCloseModal={closeModal}
    >
      <Grid
        md={12}
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        style={{ textAlign: 'center', height: '100%' }}
      >
        <Grid container alignItems="center" justify="center" spacing={4}>
          <Grid item>
            <StyledCheck />
          </Grid>
        </Grid>
        <TitleModal>Boleto gerado com sucesso!</TitleModal>
        <Grid container item>
          <Message>
            {`Seu boleto foi gerado e enviado por e-mail, você pode verificar o
              histórico dos boletos na aba "Gerenciar boleto" ou baixá-lo
              clicando no botão abaixo.`}
          </Message>
        </Grid>
        <Grid container style={{ width: '100%' }}>
          <Button
            color={colors.green}
            onClick={handleBaixarPdfBoletoDeposito}
            style={{ width: '100%' }}
            loading={loading}
          >
            Baixar boleto
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default ModalSucesso
